import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'mtn-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class TextFieldComponent {

  @Input()
  form: UntypedFormGroup;
  @Input()
  controlName: string;
  @Input()
  enableClear = false;
  @Input()
  isRequired = false;
  @Input()
  label: string;
  @Input()
  noErrorPadding = false;
  @Input()
  placeholder: string;

  constructor() {
  }

}
